import { ObservableMap } from '@stencil/store';

import {
    isLocal,
    isNonCloud,
    isStandalone,
} from '../../utils/EnvironmentUtil';
import { Features } from '../../utils/featureFlags/featureFlagConstants';
import { getFeatureFlag } from '../../utils/featureFlags/featureFlags';
import Logger from '../../utils/logger/logger';
import {
    getAccessToken,
    sessionStore,
} from '../../utils/session/sessionStore';
import { getAccountName } from '../../utils/urlHelper';
import { State } from '../types/state';

export function setModeSideEffect(store: ObservableMap<State>) {
    store.onChange('mode', async () => {
        Logger.debug('featureFlags', 'mode changed, refreshing feature flags');
        await window.PortalShell.FeatureFlags.fetchFeatureFlags(sessionStore, getAccessToken());

        const enableSelfAuth = getFeatureFlag(Features.EnablePortalShellSelfAuth.name);

        const localSession = isLocal();
        const standalone = isStandalone();

        // For Cloud, we only want to attempt sign in when there is an account name
        // For OnPrem, we always want to attempt sign in
        const hasAccountName = isNonCloud() || getAccountName();

        const session = window.PortalShell.Session;
        Logger.debug([ 'session', 'idle timeout' ], `Session from mode side effect: hasAccountName=${hasAccountName} session=${enableSelfAuth}, isLocal: ${localSession}, isSignInInitialized: ${sessionStore.get('isSignInInitialized')}, isStandalone: ${standalone}`);
        if (enableSelfAuth && !sessionStore.get('isSignInInitialized') && !standalone && hasAccountName) {
            Logger.debug('session', 'starting initialize');
            const success = await session.signInSilent(localSession);
            Logger.debug('session', `initialize complete, success: ${success}`);
        }
    });
}
